import { render, staticRenderFns } from "./delayApprovalManage.vue?vue&type=template&id=3dfa3193&scoped=true&"
import script from "./delayApprovalManage.vue?vue&type=script&lang=js&"
export * from "./delayApprovalManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa3193",
  null
  
)

export default component.exports